<template>
  <div class="w-full text-center">
    <p class="text-gray-500/80 text-sm">
      <a
        v-for="menu in menuStore.authMenu"
        :key="menu.Id"
        :href="menu.Link"
        class="text-primary font-semibold ms-1"
      >
        - {{ menu.Name }}</a
      >
    </p>
    <p
      class="mt-1 font-mono text-[10px] text-gray-500/40"
      data-build-tag
      :aria-label="`Derleme sürümü ${buildTag}`"
    >
      {{ buildTag }}
    </p>
  </div>
</template>

<script setup>
import { useMenuStore } from "@/stores/menuStore";

const buildTag = process.env.VUE_APP_BUILD_TAG || "dev-local";
const menuStore = useMenuStore();
</script>
